import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingIndicator',
  props: {
  showLoading: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_inner_loading, {
      showing: __props.showLoading,
      class: "z-max"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_spinner_facebook, {
          size: "4rem",
          color: "primary"
        })
      ]),
      _: 1
    }, 8, ["showing"])
  ]))
}
}

})